module.exports = __webpack_public_path__ + "static/img/slide3.1ed1138.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide3.webp
// module id = zTR2
// module chunks = 1